/*global Primus*/
/*eslint-disable no-console*/

import { eventChannel } from 'redux-saga';

export const CONNECTION_STATE_EVENTS = [
  'open',
  'reconnect',
  'error',
  'reconnect scheduled',
  'reconnected',
  'reconnect timeout',
  'reconnect failed',
  'end'
];

export default class Socket {

  constructor(accessToken) {
    this.primus = Primus.connect(process.env.KOOTH_API_ROOT);
    this.primus.on('outgoing::url', url => url.query = 'accessToken='+accessToken);
    this.requestPromises = {};

    window.req = this.request.bind(this);
  }

  getEventChannel() {
    return eventChannel(emitter => {
      this.primus.on('data', data => {
        console.log('Received a new message from the server', data);

        if(data.inResponseTo) {
          const { resolve, reject } = this.requestPromises[data.inResponseTo];

          if(Math.floor(data.code / 100) == 2) {
            resolve(data.body);
          }
          else {
            let message = data.code;

            if(data.code === 403) {
              message = 'You are temporarily denied access to the chat.';
            }

            reject(new Error(message));
          }

          delete this.requestPromises[data.inResponseTo];
        }

        emitter({type: 'data', data});
      });

      this.primus.on('open', () => {
        const statusMessage = 'Connection is alive and kicking';
        console.log(statusMessage);

        emitter({type: 'open', statusMessage});
      });

      this.primus.on('error', error => {
        const statusMessage = 'A connection error occured';
        console.error(statusMessage, error);

        emitter({type: 'error', error, statusMessage});

      });

      this.primus.on('reconnect', () => {
        const statusMessage = 'Reconnection attempt started';
        console.log(statusMessage);
        emitter({type: 'reconnect', statusMessage});

      });

      this.primus.on('reconnect scheduled', options => {
        const statusMessage = `Reconnecting in ${options.scheduled} ms. This is an attempt ${options.attempt} out of ${options.retries}`;
        emitter({type: 'reconnect scheduled', options, statusMessage});
      });

      this.primus.on('reconnected', options => {
        const statusMessage = `It took ${options.duration} ms to reconnect`;
        emitter({type: 'reconnected', options, statusMessage});
      });

      this.primus.on('reconnect timeout', error => {
        const statusMessage = `Timeout expired: ${error.message}`;
        console.log(statusMessage);
        emitter({type: 'reconnect timeout', error, statusMessage});
      });

      this.primus.on('reconnect failed', error => {
        const statusMessage = `The reconnection failed: ${error.message}`;
        console.log(statusMessage);
        emitter({type: 'reconnect failed', error, statusMessage});
      });

      this.primus.on('end', () => {
        const statusMessage = 'Connection closed';
        console.log(statusMessage);
        emitter({type: 'end', statusMessage});
      });

      return () => {
        emitter = () => {};
      };
    });
  }

  request(path, body = null) {
    console.log('request', path, body);

    const id =  Math.random().toString();
    const promise = new Promise((resolve, reject) => {
      this.requestPromises[id] = {resolve, reject};
    });

    this.primus.write({ path, body, id });

    return promise;
  }

  respond(inResponseTo, body, code = 200) {
    console.log('respond', inResponseTo, body);
    this.primus.write({ inResponseTo, body, code });
  }

  refreshToken(accessToken) {
    this.primus.on('outgoing::url', url => url.query = 'accessToken='+accessToken);
    return this.request('auth.provide', { accessToken });
  }

  chatEnqueue() {
    return this.request('chat.add-to-queue');
  }

  chatEnqueueCancel() {
    return this.request('chat.remove-from-queue');
  }

  chatSendMessage(chatMessage) {
    return this.request('chat.send-message', chatMessage);
  }

  chatStartWritingMessage() {
    return this.request('chat.start-writing-message');
  }

  chatStopWritingMessage() {
    return this.request('chat.stop-writing-message');
  }

  chatQuestionnaireSubmit(questionnaire) {
    return this.request('chat.questionnaire-progress', questionnaire);
  }

  forumThreadWatch(id) {
    return this.request('forum.watch', { id });
  }

  forumThreadUnwatch(id) {
    return this.request('forum.unwatch', { id });
  }
}



/** WEBPACK FOOTER **
 ** ./src/members/state/__shared__/socket.js
 **/